export function computeTourPanelLeftPx(params) {
    const { horizontal, targetLeft, targetWidth, panelWidth, viewportWidth, margin } = params;
    const targetCenterX = targetLeft + targetWidth / 2;
    let left;
    switch (horizontal) {
        case 'start':
            left = targetLeft;
            break;
        case 'end':
            left = targetLeft + targetWidth - panelWidth;
            break;
        case 'center':
        default:
            left = targetCenterX - panelWidth / 2;
    }
    return Math.max(margin, Math.min(left, viewportWidth - margin - panelWidth));
}
